import { render, staticRenderFns } from "./Article10.vue?vue&type=template&id=4a243414&"
import script from "./Article10.vue?vue&type=script&lang=js&"
export * from "./Article10.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports